<app-modal [info]="info" (closeModal)="closeModal($event)">
  <ng-template #submitWithClothingContent>
    @if (action) {
      <button
        id="m-limitation-action-btn"
        [routerLink]="[action.routerLink]"
        [queryParams]="action.routerParams ? action.routerParams : null"
        (click)="closeModal(true)"
        class="btn btn--new-primary small bright modal-btn">
        <span class="btn__text">
          {{ action.text | translate }}
        </span>
      </button>
    }
  </ng-template>
</app-modal>
